import { style } from "./Style.js";

import { Draggable } from "react-beautiful-dnd";


import ItemCard from "./ItemCard.js";

export default function ItemDraggable (props)
{
    return (
	<Draggable draggableId={props.itemId} index={props.index} isDragDisabled={props.state === "applied" || props.state === "missed"}>
	    {(provided, snapshot) => {
		return (
		    <div { ...provided.draggableProps } { ...provided.dragHandleProps } ref={provided.innerRef} style={{ ...provided.draggableProps.style, ...style.modal.draggable.style }} className="pb-1">
			<ItemCard itemId={props.itemId} placement="auto" state={props.state}/>
		    </div>
		);
	    }}
	</Draggable>
    );
}
